/** @constant
    @description Describes expiration in days from donation date collection
*/
export const PRODUCT_EXPIRATIONS = {
  PRBS: 35,
  FRESH_FROZEN_PLASMA: 365,
  WHOLE_BLOOD: 21,
  FROZEN_PLASMA: 1825,
};
